/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import * as Array from 'fierry/util/array';

import ZoneCass from 'solis/logic/board/zone/cass';
import ZoneInfluences from 'solis/logic/board/zone/influences';
import ZoneUsers from 'solis/logic/board/zone/users';
import ZoneUserControl from 'solis/logic/board/zone/user.control';


export default class ZoneControl extends Logic
{
  constructor (zone)
  {
    super(zone);

    this.users = new ZoneUsers(zone);
  }


  update (now)
  {
    const cass = new ZoneCass(this.object);

    for (const entry of this.getUsers())
    {
      cass.updateControl(entry.user, entry.getControl(now));
    }

    this.object.set({ updateDate: now });
  }


  updateUser ()
  {
    const winner = this.calculateWinner();

    if (winner === this.users.getCurrentUser())
    {
      return;
    }

    this.replaceWinner(winner, this.users.getCurrentUser());

    new ZoneCass(this.object).updateCurrentUser(winner);
  }


  replaceWinner (currentUser, previousUser)
  {
    if (previousUser === this.users.getColonyUser())
    {
      const influences = new ZoneInfluences(this.object);

      influences.destroyUserInfluences(previousUser);
      influences.establishEnemyInfluences();
    }
  }


  calculateWinner ()
  {
    let entries = [ ...this.cass.control ];

    if (this.users.getEstablishedUsers().length !== 0)
    {
      entries = entries.filter(entry => entry.user !== this.users.getColonyUser());
    }

    const found = Array.findMax(entries, entry => entry.value);

    return found !== null ? found.user : this.users.getInfluenceWinner();
  }


  getControlWinner (now)
  {
    const found = Array.findMax(this.getUsers(), entry => entry.getControl(now));

    return found !== null ? found.user : null;
  }


  getChallengerRatio (now)
  {
    const challenger = Array.findMax(this.getChallengers(), entry => entry.getControl(now));

    if (challenger === null)
    {
      return 0;
    }

    return Math.min(challenger.getControl(now) / this.getCurrentUser().getControl(now), 1);
  }


  getUsers ()
  {
    return this.users.getActiveUsers().map(user => new ZoneUserControl(this.object, user));
  }


  getChallengers ()
  {
    return this.users.getChallengers().map(user => new ZoneUserControl(this.object, user));
  }


  getCurrentUser ()
  {
    return new ZoneUserControl(this.object, this.cass.currentUser);
  }


};
